module.exports = __webpack_public_path__ + "img/img-404.5ebfcdbe.png";